import React, { useRef, useEffect } from 'react';
import useNebula from 'hooks/useNebula';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  viz: {
    height: 600,
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('xs')]: {
    //   height: 200,
    },
  },
}));

const Butter = () => {
  const nebula = useNebula();
  const elementRef = useRef();
  const vizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;

    vizRef.current = await nebula.render({
      element: elementRef.current,
      type: 'butterfly',
      fields: [
        {
          qDef: {
            qFieldDefs: ['=$(vValueList)'],
            qSortCriterias: [{
              qSortByAscii: 0,
              qSortByLoadOrder: -1,
            }],

          },
        },
        {
          qDef: {
            qDef: `If($(vValueList)='# of Media Outlets',
            209*-1,//Count(distinct {<"Year - Comp All"={'2021'}>} [Name of media outlet completing the survey - Comp All])*-1,
              
            If($(vValueList)='# of Journalist',
              Sum({<"Year - Comp All"={'2021'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Men',
              Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Women',
              Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Non-Binary',
              Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Supervisors',
              Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Full-time',
              Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Part-time',
              Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Interns',
              Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Indigenous',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All])*-1,
              
              If($(vValueList)='# of Asian',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All])*-1,
                 
              If($(vValueList)='# of Black',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Latin',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All])*-1,
              
              If($(vValueList)='# of Middle Eastern',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All])*-1,
              
              If($(vValueList)='# of White',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All])*-1,
                 
              If($(vValueList)='# of Mixed Race',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All])*-1,
                  
              If($(vValueList)='# of Unknown',
              Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])*-1
          
          )))))))))))))))))
          
          `,
          },
        },
        {
          qDef: {
            qDef: `If($(vValueList)='# of Media Outlets',
            242,//Count(distinct {<"Year - Comp All"={'2022'}>} [Name of media outlet completing the survey - Comp All]),
              
            If($(vValueList)='# of Journalist',
              5012,//Sum({<"Year - Comp All"={'2022'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Men',
              Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Women',
              Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Non-Binary',
              Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
             
            If($(vValueList)='# of Supervisors',
              Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Full-time',
              Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Part-time',
              Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Interns',
              Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Indigenous',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
              
              If($(vValueList)='# of Asian',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
                 
              If($(vValueList)='# of Black',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Latin',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
              
              If($(vValueList)='# of Middle Eastern',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
              
              If($(vValueList)='# of White',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
                 
              If($(vValueList)='# of Mixed Race',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
                  
              If($(vValueList)='# of Unknown',
              Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
          
          )))))))))))))))))
          
          
          `,
          },
        },
      ],
    });
  }, [nebula]);

  const classes = useStyles();

  return (
    <Box className={classes.butterChart}>
      <div id="butterViz" className={classes.viz} ref={elementRef} />
    </Box>
  );
};

export default Butter;
